import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'
import PostGraduateResults2026 from 'src/components/PostGraduationContent/Residence2026/Results/PostGraduateResults2026'

const Results2026 = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <PostGraduateResults2026 />
      <Footer />
    </>
  )
}

export default Results2026
